// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon[data-v-bc7b3f8e] {\n  font-size: 1.5em;\n  padding: 5px 10px;\n}\n.content.md > *[data-v-bc7b3f8e] {\n  padding: 10px 20px;\n}\n.content.md > *[data-v-bc7b3f8e]:last-child {\n  border-left: 1px solid var(--main-gray-2);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
